/**
 * Component Registry for Tower 12
 * 
 * Inherits from @vibesites-weidner-apartment-homes/theme-weidner-classic-theme and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-weidner-apartment-homes/theme-weidner-classic-theme/registry';
import { AmenitiesList } from './components/AmenitiesList';
import { ApartmentSyncSection } from './components/ApartmentSyncSection';
import { FloorplanDetails } from './components/FloorplanDetails';
import { Footer } from './components/Footer';
import { FutureResidentsClub } from './components/FutureResidentsClub';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Penthouse } from './components/Penthouse';
import { PetPolicy } from './components/PetPolicy';
import { ResidentAccess } from './components/ResidentAccess';
import { VirtualTourEmbed } from './components/VirtualTourEmbed';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  AmenitiesList,
  ApartmentSyncSection,
  FloorplanDetails,
  Footer,
  FutureResidentsClub,
  Header,
  Hero,
  Penthouse,
  PetPolicy,
  ResidentAccess,
  VirtualTourEmbed,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
